import type { AppInstallationFields } from '@tribeplatform/gql-client/graphql'
import type {
  PaginatedAppInstallation,
  QueryGetNetworkAppInstallationsArgs,
} from '@tribeplatform/gql-client/types'

import {
  useInfiniteQuery,
  type UseInfiniteQueryOptions,
} from '../../lib/react-query/useInfiniteQuery.js'
import { useTribeClient } from '../../useTribeClient.js'
import { getAppInstallationsKey } from '../../utils/keys/app.key.js'

export const useAppInstallations = (options: {
  variables: QueryGetNetworkAppInstallationsArgs
  fields?: AppInstallationFields
  useInfiniteQueryOptions?: UseInfiniteQueryOptions<PaginatedAppInstallation>
}) => {
  const { variables, fields = 'basic', useInfiniteQueryOptions } = options || {}
  const { client } = useTribeClient()
  const appInstallationsKey = getAppInstallationsKey({ variables, fields })

  return useInfiniteQuery<PaginatedAppInstallation>(
    appInstallationsKey,
    ({ pageParam: after }) =>
      client?.app.appInstallations({ after, ...variables }, fields),
    useInfiniteQueryOptions,
  )
}
